export default {
  default_lang_code: "en-US",
  idletimeout_duration: 60, //timeout in minutes
  toc_open: window.innerWidth > 960, //applies to helpsets, IPC, folderview
  topic_infinite_scroll: false,
  control_property_data: {},
  kb_rest_server: "",
  add_to_cart: true,
  item_lang_tree: {},
  has_autofill: false,
  root_path: {}, // used for parent path
  partition_size: 3, // must use odd number > 3
  max_results: 15,
  search_term: { searchterm: "" },
  filter_helpset_id: "",
  control_values: {},
  panel_control_defs: [],
  pub_search_results: [],
  search_results: [],
  is_results_loading: true,
  current_results_page: 1,
  shorcut_extId: "",
  control_def_data_array: [],
  mime_types: "",
  panel_control_defs_json: { PanelControlValues: { lstValues: [] } },
  property_filter_state: [],
  partcart: [],
  parents: [],
  publications: [],
};
